/*
 * aaa-size-guide.js
 * Web-component island for the Ego7 boot size finder.
 * Reads the live variant radios on the PDP so it only ever offers sizes that
 * exist (and are in stock), then writes the customer's choice back to the
 * FOOT SIZE + CALF SIZE option inputs and dispatches change so the theme's
 * variant-picker updates price, availability and the ?variant= URL.
 *
 * No theme-internal imports: plain custom element, loaded as a classic asset.
 * Behaviour lives here (Section F.9 island pattern), not in inline script.
 */
(function () {
  if (customElements.get('size-guide-finder')) return;

  // Ego7 tall-boot fit matrix. Per foot size (EU): four boot heights (cm) for
  // steps -1/0/+1/+2, and four calf circumference bands (cm) for XS/S/M/L.
  // XL is a real variant width but Ego7 publish no band for it (see note).
  var TALL = {
    '34': { h: ['39', '41', '43', '45'], c: ['28.0-30.1', '30.2-32.3', '32.4-34.5', '34.6-36.8', null] },
    '35': { h: ['40', '42', '44', '46'], c: ['29.0-31.1', '31.2-33.3', '33.4-35.5', '35.6-37.8', null] },
    '36': { h: ['41', '43', '45', '47'], c: ['29.0-31.1', '31.2-33.3', '33.4-35.5', '35.6-37.8', null] },
    '37': { h: ['42', '44', '46', '48'], c: ['29.5-31.6', '31.7-33.8', '33.9-36.0', '36.1-38.3', '38.4-40.6'] },
    '38': { h: ['43', '45', '47', '49'], c: ['30.0-32.1', '32.2-34.3', '34.4-36.5', '36.6-38.8', '38.9-41.0'] },
    '39': { h: ['44', '46', '48', '50'], c: ['31.0-33.1', '33.2-35.3', '35.4-37.5', '37.6-39.8', '39.9-42.0'] },
    '40': { h: ['44.5', '46.5', '48.5', '50.5'], c: ['31.5-33.6', '33.7-35.8', '35.9-38.0', '38.1-40.3', '40.4-42.5'] },
    '41': { h: ['45', '47', '49', '51'], c: ['32.0-34.1', '34.2-36.3', '36.4-38.5', '38.6-40.8', '40.9-43.0'] },
    '42': { h: ['45.5', '47.5', '49.5', '51.5'], c: ['32.5-34.6', '34.7-36.8', '36.9-39.0', '39.1-41.3', '41.4-43.6'] },
    '43': { h: ['46', '48', '50', '52'], c: ['33.0-35.1', '35.2-37.3', '37.4-39.5', '39.6-41.8', 'from 41.8'] },
    '44': { h: ['46.5', '48.5', '50.5', '52.5'], c: ['33.5-35.6', '35.7-37.8', '37.9-40.0', '40.1-42.3', 'from 42.3'] },
    '45': { h: ['47', '49', '51', '53'], c: ['34.0-36.1', '36.2-38.3', '38.4-40.5', '40.6-42.8', 'from 42.8'] }
  };
  var HC = ['-1', '0', '+1', '+2'];
  var WC = ['XS', 'S', 'M', 'L', 'XL'];

  // Ego7 short-boot EU / UK / US conversion (man / woman).
  var SHORT = [
    ['35', '3', '3', '3.5', '5'], ['36', '4', '4', '4.5', '6'], ['37', '4.5', '4.5', '5', '6.5'],
    ['38', '5.5', '5.5', '6', '7.5'], ['39', '6', '6', '6.5', '8'], ['40', '6.5', '7', '7.5', '9'],
    ['41', '7', '8', '8', '9.5'], ['42', '8', '8', '9.5', '10'], ['43', '9', '9', '10', '10.5'],
    ['44', '8.5', '-', '10.5', '-'], ['45', '10.5', '-', '11.5', '-']
  ];

  // Ego7 KIDS tall-boot matrix (separate chart: same foot number maps to
  // different heights/calf than adults). Heights only for steps 0 and +1;
  // widths only S/M/L. Slots kept at [-1,0,+1,+2] / [XS,S,M,L,XL] with nulls.
  var KIDS = {
    '32': { h: [null, '31.5', '34', null], c: [null, '22.6-24.5', '24.6-26.5', '26.6-28.5', null] },
    '33': { h: [null, '32.5', '35', null], c: [null, '23.5-25.4', '25.5-27.4', '27.5-29.4', null] },
    '34': { h: [null, '34', '36.5', null], c: [null, '24.4-26.3', '26.4-28.3', '28.4-30.3', null] },
    '35': { h: [null, '35', '37.5', null], c: [null, '25.4-27.3', '27.4-29.3', '29.4-31.3', null] },
    '36': { h: [null, '36.5', '39', null], c: [null, '26.5-28.4', '28.5-30.4', '30.5-32.4', null] },
    '37': { h: [null, '38', '40.5', null], c: [null, '27.5-29.4', '29.5-31.4', '31.5-33.4', null] },
    '38': { h: [null, '39.5', '42', null], c: [null, '28.5-30.4', '30.5-32.4', '32.5-34.4', null] }
  };

  function esc(s) { return String(s).replace(/"/g, '&quot;'); }

  class SizeGuideFinder extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.type = this.getAttribute('data-guide-type') || 'tall';
      this.footOption = this.getAttribute('data-foot-option') || 'FOOT SIZE';
      this.calfOption = this.getAttribute('data-calf-option') || 'CALF SIZE';
      this.MATRIX = (this.type === 'tall_kids') ? KIDS : TALL;
      this.foot = null; this.hSel = null; this.wSel = null;
      this.bindTrigger();
      if (this.type === 'short') { this.renderShort(); } else { this.renderTall(); }
    }
    bindTrigger() {
      var self = this;
      var root = this.closest('.aaa-size-guide');
      if (!root) return;
      var trig = root.querySelector('.aaa-size-guide__trigger');
      if (trig && !trig.dataset.sgTracked) {
        trig.dataset.sgTracked = '1';
        trig.addEventListener('click', function () { self.track('size_guide_open', {}); });
      }
    }
    track(name, params) {
      try {
        params = params || {};
        params.guide_type = this.type;
        // Primary path on this store: Shopify Web Pixels (Customer Events).
        // gtag/dataLayer are NOT present on the storefront, so this is what reaches GA4.
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, params);
        }
        if (window.gtag) { window.gtag('event', name, params); }
        if (window.dataLayer && window.dataLayer.push) { window.dataLayer.push(Object.assign({ event: name }, params)); }
        document.dispatchEvent(new CustomEvent('size-guide:' + name, { detail: params }));
      } catch (e) {}
    }

    radios(optionName) {
      var prefix = (optionName + '-').toLowerCase();
      return Array.prototype.filter.call(
        document.querySelectorAll('input[type="radio"]'),
        function (i) { return i.name && i.name.toLowerCase().indexOf(prefix) === 0; }
      );
    }
    isAvailable(radio) {
      if (!radio) return false;
      if (radio.disabled) return false;
      var label = radio.closest('label');
      if (label && /unavailable|sold-?out|disabled/i.test(label.className)) return false;
      return true;
    }

    availableFeet() {
      var found = {};
      this.radios(this.footOption).forEach(function (r) { found[r.value] = true; });
      var keys = Object.keys(found);
      if (keys.length) return keys.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
      return Object.keys(this.MATRIX);
    }
    calfState() {
      var map = {}; var self = this;
      this.radios(this.calfOption).forEach(function (r) { map[r.value] = self.isAvailable(r); });
      return map;
    }

    // ---- TALL ----
    renderTall() {
      var feet = this.availableFeet();
      if (this.foot === null) this.foot = feet.indexOf('37') > -1 ? '37' : feet[0];
      var footChips = feet.map(function (f) {
        return '<button type="button" class="aaa-sg__chip" data-foot="' + esc(f) + '" aria-pressed="' + (f === this.foot) + '">' + f + '</button>';
      }, this).join('');
      this.innerHTML =
        '<div class="aaa-sg">' +
          '<div class="aaa-sg__step"><span class="aaa-sg__label">1 &middot; Foot size (EU)</span>' +
            '<div class="aaa-sg__chips" data-row="foot">' + footChips + '</div></div>' +
          '<div data-row="detail"></div>' +
          '<div class="aaa-sg__tip"><span class="aaa-sg__tip-i" aria-hidden="true">i</span><span class="aaa-sg__tip-text">Add 0.5 to 1 cm to your height measurement; boots settle after a few rides.</span></div>' +
        '</div>';
      this.querySelector('[data-row="foot"]').addEventListener('click', this.onFoot.bind(this));
      this.renderDetail();
    }
    onFoot(e) {
      var b = e.target.closest('[data-foot]'); if (!b) return;
      this.foot = b.getAttribute('data-foot'); this.hSel = null; this.wSel = null;
      this.querySelectorAll('[data-row="foot"] .aaa-sg__chip').forEach(function (c) {
        c.setAttribute('aria-pressed', c.getAttribute('data-foot') === this.foot);
      }, this);
      this.renderDetail();
    }
    renderDetail() {
      var host = this.querySelector('[data-row="detail"]'); if (!host) return;
      var self = this;
      var d = this.MATRIX[this.foot];
      if (!d) {
        host.innerHTML = '<p class="aaa-sg__hint">Detailed fit data for size ' + this.foot +
          ' is coming soon. Measure your calf and pick from the options on the product, or contact us if unsure.</p>';
        return;
      }
      var calf = this.calfState();
      var tokens = Object.keys(calf);
      var hasDom = tokens.length > 0;
      var availH = {}, availW = {};
      tokens.forEach(function (t) { var p = t.split('/'); availW[p[0]] = true; availH[p[1]] = true; });

      if (this.hSel !== null && hasDom && !availH[HC[this.hSel]]) this.hSel = null;

      var heights = [];
      d.h.forEach(function (v, i) { if (v != null && (!hasDom || availH[HC[i]])) heights.push(i); });
      var hChips = heights.map(function (i) {
        return '<button type="button" class="aaa-sg__chip aaa-sg__chip--stack" data-h="' + i + '" aria-pressed="' + (self.hSel === i) + '"><strong>' + d.h[i] + '</strong><span>' + HC[i] + '</span></button>';
      }).join('');

      var widths = [];
      WC.forEach(function (w, i) { if (!hasDom || availW[w]) widths.push(i); });
      var wRows = widths.map(function (i) {
        var w = WC[i];
        var cv = d.c[i]; var range = cv ? cv : 'wider than L';
        var dis = false;
        if (self.hSel !== null && hasDom) { dis = calf[w + '/' + HC[self.hSel]] !== true; }
        if (self.wSel === i && dis) self.wSel = null;
        return '<button type="button" class="aaa-sg__row" data-w="' + i + '"' + (dis ? ' disabled' : '') +
          ' aria-pressed="' + (self.wSel === i) + '"><span class="aaa-sg__row-w">' + w + '</span>' +
          '<span class="aaa-sg__row-c">' + range + (range === 'wider than L' ? '' : ' cm') + '</span></button>';
      }).join('');

      host.innerHTML =
        '<div class="aaa-sg__step"><span class="aaa-sg__label">2 &middot; Boot height (cm)</span>' +
          '<div class="aaa-sg__chips" data-row="h">' + hChips + '</div>' +
          '<p class="aaa-sg__note">The number below each height (-1 to +2) is Ego7&rsquo;s height step, about 2 cm taller per step.</p></div>' +
        '<div class="aaa-sg__step"><span class="aaa-sg__label">3 &middot; Calf width (cm circumference)</span>' +
          '<div class="aaa-sg__rows" data-row="w">' + wRows + '</div></div>' +
          this.resultHtml(calf, hasDom);
      host.querySelector('[data-row="h"]').addEventListener('click', function (e) {
        var b = e.target.closest('[data-h]'); if (!b) return;
        self.hSel = parseInt(b.getAttribute('data-h'), 10);
        requestAnimationFrame(function () { self.renderDetail(); });
      });
      host.querySelector('[data-row="w"]').addEventListener('click', function (e) {
        var b = e.target.closest('[data-w]'); if (!b || b.disabled) return;
        self.wSel = parseInt(b.getAttribute('data-w'), 10);
        requestAnimationFrame(function () { self.renderDetail(); });
      });
      var cta = host.querySelector('[data-choose]');
      if (cta) cta.addEventListener('click', this.choose.bind(this));
    }
    resultHtml(calf, hasDom) {
      if (this.hSel === null || this.wSel === null) {
        return '<p class="aaa-sg__hint">Pick a height and calf width to see your size.</p>';
      }
      var token = WC[this.wSel] + '/' + HC[this.hSel];
      var avail = hasDom ? (calf[token] === true) : true;
      var d = this.MATRIX[this.foot];
      var note = (this.wSel === 4 && (!d || !d.c[4])) ? '<span class="aaa-sg__sub">Between sizes? Contact us before ordering XL.</span>' : '';
      if (!avail) {
        return '<div class="aaa-sg__result aaa-sg__result--out"><span class="aaa-sg__rlabel">Foot ' + this.foot + ' &middot; Calf ' + token + '</span>' +
          '<span class="aaa-sg__sub">That combination is out of stock. Try a nearby height or width.</span></div>';
      }
      return '<div class="aaa-sg__result"><span class="aaa-sg__rlabel">Your size</span>' +
        '<span class="aaa-sg__code">Foot <strong>' + this.foot + '</strong> &middot; Calf <strong>' + token + '</strong></span>' + note +
        '<button type="button" class="button aaa-sg__cta" data-choose>Choose this size</button></div>';
    }
    choose() {
      if (this.hSel === null || this.wSel === null) return;
      var token = WC[this.wSel] + '/' + HC[this.hSel];
      var set = function (radios, val) {
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === val) {
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
            return true;
          }
        }
        return false;
      };
      var okF = set(this.radios(this.footOption), this.foot);
      var okC = set(this.radios(this.calfOption), token);
      this.track('size_guide_apply', { size: this.foot + ' ' + token });
      var dlg = this.closest('dialog-component');
      if (dlg && typeof dlg.closeDialog === 'function') dlg.closeDialog();
      if (okF || okC) {
        var buy = document.querySelector('.buy-buttons-block, buy-buttons-component, [data-block-type="buy-buttons"], add-to-cart-component');
        if (buy && buy.scrollIntoView) buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    // ---- SHORT ----
    renderShort() {
      var self = this;
      var feetSet = {};
      this.radios(this.footOption).forEach(function (r) { feetSet[r.value] = true; });
      var hasFeet = Object.keys(feetSet).length > 0;
      var rows = SHORT.filter(function (r) { return !hasFeet || feetSet[r[0]]; }).map(function (r) {
        return '<button type="button" class="aaa-sg__trow" data-foot="' + esc(r[0]) + '">' +
          '<span>' + r[0] + '</span><span>' + r[1] + '</span><span>' + r[2] + '</span><span>' + r[3] + '</span><span>' + r[4] + '</span></button>';
      }).join('');
      this.innerHTML =
        '<div class="aaa-sg aaa-sg--short">' +
          '<div class="aaa-sg__thead"><span>EU</span><span>UK M</span><span>UK W</span><span>US M</span><span>US W</span></div>' +
          '<div class="aaa-sg__tbody">' + rows + '</div>' +
          '<p class="aaa-sg__hint">Tap your EU size to select it on the product.</p>' +
        '</div>';
      this.querySelector('.aaa-sg__tbody').addEventListener('click', function (e) {
        var b = e.target.closest('[data-foot]'); if (!b) return;
        var radios = self.radios(self.footOption);
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === b.getAttribute('data-foot')) {
            radios[i].checked = true; radios[i].dispatchEvent(new Event('change', { bubbles: true })); break;
          }
        }
        self.track('size_guide_apply', { size: b.getAttribute('data-foot') });
        var dlg = self.closest('dialog-component');
        if (dlg && typeof dlg.closeDialog === 'function') dlg.closeDialog();
      });
    }
  }

  customElements.define('size-guide-finder', SizeGuideFinder);
})();
